import React from 'react';

export const customIcons = {
  arrowLeft: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M15.41 7.41L14 6 8 12 14 18 15.41 16.59 10.83 12z"
            transform="translate(-472 -470) translate(472 470)"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  group: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
            transform="translate(-940 -177) translate(940 177)"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  invoice: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
            transform="translate(-1264 -434) translate(1264 434)"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  person: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
            transform="translate(-940 -141) translate(940 141)"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  sort: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
            transform="translate(-1156 -177) translate(1156 177)"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  archived: {
    path: (
      <g fill="currentColor">
        <g>
          <g>
            <g>
              <path
                d="M6.8 3H3.2c-.66 0-1.194.563-1.194 1.25L2 11.75c0 .688.54 1.25 1.2 1.25h9.6c.66 0 1.2-.563 1.2-1.25V5.5c0-.688-.54-1.25-1.2-1.25H8L6.8 3z"
                transform="translate(-906 -1288) translate(271 1280) translate(584) translate(51 8)"
              />
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 16 16',
  },
  cross: {
    path: (
      <g fill="currentColor">
        <g>
          <g>
            <g>
              <path
                d="M12 4.806L11.194 4 8 7.194 4.806 4 4 4.806 7.194 8 4 11.194 4.806 12 8 8.806 11.194 12 12 11.194 8.806 8z"
                transform="translate(-955 -1734) translate(271 1535) translate(649 191) translate(35 8)"
              />
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 16 16',
  },
  deleted: {
    path: (
      <g fill="currentColor">
        <g>
          <g>
            <g>
              <path
                d="M8 2C4.688 2 2 4.688 2 8s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6zm3 7H5V7h6v2z"
                transform="translate(-914 -778) translate(271 770) translate(584) translate(59 8)"
              />
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 16 16',
  },
  draft: {
    path: (
      <g fill="currentColor">
        <g>
          <g>
            <g>
              <path
                d="M2 11.468V14h2.532L12 6.532 9.468 4 2 11.468zm11.8-6.714c.266-.266.266-.695 0-.96l-1.593-1.595c-.266-.265-.695-.265-.96 0L10 3.446 12.554 6l1.247-1.246z"
                transform="translate(-928 -1543) translate(271 1535) translate(584) translate(73 8)"
              />
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 16 16',
  },
  check: {
    path: (
      <g fill="currentColor">
        <g>
          <g>
            <g>
              <path
                d="M5.814 11.48L2.969 8.37 2 9.421 5.814 13.59 14 4.641 13.038 3.59z"
                transform="translate(-925 -1479) translate(271 1280) translate(649 191) translate(5 8)"
              />
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 16 16',
  },
  close: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            transform="translate(-148 -434) translate(148 434)"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  middleCheck: {
    path: (
      <g fill="currentColor">
        <g>
          <g>
            <path
              d="M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 2C4.686 2 2 4.686 2 8s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6z"
              transform="translate(-510 -597) translate(304 573) translate(206 24)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 16 16',
  },
  calendar: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
            transform="translate(-1300 -141) translate(1300 141)"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  duplicate: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z"
            transform="translate(-1192 -434) translate(1192 434)"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  trash: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
            transform="translate(-76 -141) translate(76 141)"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  send: {
    path: (
      <g fill="currentColor">
        <g>
          <path d="m8.75 17.612v4.638c0 .324.208.611.516.713.077.025.156.037.234.037.234 0 .46-.11.604-.306l2.713-3.692z" />
          <path d="m23.685.139c-.23-.163-.532-.185-.782-.054l-22.5 11.75c-.266.139-.423.423-.401.722.023.3.222.556.505.653l6.255 2.138 13.321-11.39-10.308 12.419 10.483 3.583c.078.026.16.04.242.04.136 0 .271-.037.39-.109.19-.116.319-.311.352-.53l2.75-18.5c.041-.28-.077-.558-.307-.722z" />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  brief: {
    path: (
      <g fill="currentColor">
        <g>
          <g>
            <g>
              <path
                d="M12.667 2.3H9.88C9.6 1.546 8.867 1 8 1s-1.6.546-1.88 1.3H3.333C2.6 2.3 2 2.885 2 3.6v9.1c0 .715.6 1.3 1.333 1.3h9.334C13.4 14 14 13.415 14 12.7V3.6c0-.715-.6-1.3-1.333-1.3zM8 2.3c.367 0 .667.292.667.65 0 .357-.3.65-.667.65-.367 0-.667-.292-.667-.65 0-.358.3-.65.667-.65zm1.333 9.1H4.667v-1.3h4.666v1.3zm2-2.6H4.667V7.5h6.666v1.3zm0-2.6H4.667V4.9h6.666v1.3z"
                transform="translate(-1115 -112) translate(1099 68) translate(0 32) translate(16 12)"
              />
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 16 16',
  },
  lock: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
            transform="translate(-580 -141) translate(580 141)"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  undo: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M10.385,1.499C10.096,1.378,9.76,1.446,9.537,1.667L0.228,8.98c-0.304,0.302-0.304,0.797,0,1.1
			l9.309,7.278c0.148,0.15,0.348,0.229,0.549,0.229c0.102,0,0.203-0.021,0.299-0.059c0.291-0.121,0.465-0.404,0.465-0.719V12.45
			c9.955,0,14.309,2.808,13.646,11.751C28.713,9.893,20.619,6.659,10.85,6.659V2.217C10.849,1.902,10.676,1.619,10.385,1.499z"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 25.64 25.64',
  },
  link: {
    path: (
      <g fill="currentColor">
        <g>
          <path
            d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
            transform="translate(-220 -141) translate(220 141)"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  unlink: {
    path: (
      <g fill="currentColor">
        <g>
          <g>
            <g>
              <path
                d="M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16v-2zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z"
                transform="translate(-1005 -305) translate(40 281) translate(860) translate(105 24)"
              />
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  logout: {
    path: (
      <g fill="currentColor">
        <g>
          <g>
            <g transform="translate(-1328 -16) translate(72) translate(1256 16)">
              <g>
                <path
                  d="M12 3v2l-6-.001v14L12 19v2l-6-.001V21H4V3h8zm3.41 2.543L22 12l-6.59 6.347-1.42-1.41L18.17 13H8.016v-2H18.17L14 6.953l1.41-1.41z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  calculator: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <path
              d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5.97 4.06L14.09 6l1.41 1.41L16.91 6l1.06 1.06-1.41 1.41 1.41 1.41-1.06 1.06-1.41-1.4-1.41 1.41-1.06-1.06 1.41-1.41-1.41-1.42zm-6.78.66h5v1.5h-5v-1.5zM11.5 16h-2v2H8v-2H6v-1.5h2v-2h1.5v2h2V16zm6.5 1.25h-5v-1.5h5v1.5zm0-2.5h-5v-1.5h5v1.5z"
              transform="translate(-1048 -73) translate(1048 73)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  comment: {
    path: (
      <g fill="currentColor">
        <path
          d="M6,2h48c3.252,0,6,2.748,6,6v33c0,3.252-2.748,6-6,6H25.442L15.74,57.673C15.546,57.885,15.276,58,15,58
	c-0.121,0-0.243-0.022-0.361-0.067C14.254,57.784,14,57.413,14,57V47H6c-3.252,0-6-2.748-6-6L0,8C0,4.748,2.748,2,6,2z"
        />
      </g>
    ),
    viewBox: '0 0 60 60',
  },
  download: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <path
              d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
              transform="translate(-1120 -379) translate(1120 379)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  edit: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <path
              d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
              transform="translate(-544 -141) translate(544 141)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  help: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
              transform="translate(-1048 -141) translate(1048 141)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  hourglass: {
    path: (
      <g>
        <path
          d="M336.655,202.803c33.946-30.949,79.852-72.806,84.036-172.803H451V0H61v30h30.309
			c4.184,99.997,50.09,141.854,84.036,172.803C198.116,223.564,211,236.271,211,256s-12.884,32.436-35.655,53.197
			C141.399,340.146,95.493,382.003,91.309,482H61v30h390v-30h-30.309c-4.184-99.997-50.09-141.854-84.036-172.803
			C313.884,288.436,301,275.729,301,256S313.884,223.564,336.655,202.803z M241,368.438c-4.633,0.956-9.21,2.347-13.677,4.195
			l-91.877,38.019c15.004-38.15,39.17-60.193,60.111-79.285C218.927,310.06,241,289.935,241,256V368.438z M316.443,331.367
			c20.941,19.092,45.106,41.135,60.111,79.284l-91.877-38.019c-4.467-1.848-9.044-3.239-13.677-4.195V256
			C271,289.935,293.073,310.06,316.443,331.367z M134.919,100c-7.253-18.899-12.262-41.718-13.573-70h269.307
			c-1.311,28.282-6.319,51.101-13.573,70H134.919z"
          fill="currentColor"
        />
      </g>
    ),
    viewBox: '0 0 512 512',
  },
  resource: {
    path: (
      <g fill="currentColor">
        <g>
          <g>
            <path
              d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 10H6v-2h8v2zm4-4H6v-2h12v2z"
              transform="translate(-24 -393) translate(0 377) translate(24 16)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  arrowUp: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <path
              d="M20 11L7.83 11 13.42 5.41 12 4 4 12 12 20 13.41 18.59 7.83 13 20 13z"
              transform="translate(-436 -249) translate(436 249) rotate(90 12 12)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  copy: {
    path: (
      <g stroke="none" strokeWidth="1" fill="currentColor">
        <path
          d="M11.17,2 C11.7,2 12.21,2.21 12.58,2.58 L12.58,2.58 L21.41,11.41 C22.2,12.2 22.2,13.46 21.42,14.24 L21.42,14.24 L14.25,21.41 C13.47,22.19 12.2,22.19 11.42,21.41 L11.42,21.41 L2.59,12.58 C2.21,12.21 2,11.7 2,11.17 L2,11.17 L2,4 C2,2.9 2.9,2 4,2 L4,2 Z M11.17,4 L4,4 L4,11.17 L12.83,20 L20,12.83 L11.17,4 Z M6.5,5 C7.32842712,5 8,5.67157288 8,6.5 C8,7.32842712 7.32842712,8 6.5,8 C5.67157288,8 5,7.32842712 5,6.5 C5,5.67157288 5.67157288,5 6.5,5 Z"
          id="Combined-Shape"
          fill="currentColor"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  pending: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <g>
              <g>
                <path
                  d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm-5 6.5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm5 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm5 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z"
                  transform="translate(-312 -2066) translate(280 1844) translate(24 213) translate(8 9.5)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 25',
  },
  clock: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <path
              d="M11.99 2C17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12S6.47 2 11.99 2zM12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm.5 3v5.25l4.5 2.67-.75 1.23L11 13V7h1.5z"
              transform="translate(-220 -219) translate(220 219)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  gbp: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <path
              d="M17.4 20.28v-2.304h-6.072V12.72h3.888v-2.016h-3.888v-2.16c0-.384.06-.752.18-1.104.12-.352.3-.664.54-.936.24-.272.532-.492.876-.66.344-.168.74-.252 1.188-.252.512 0 .976.092 1.392.276.416.184.8.436 1.152.756L18.6 4.536c-.592-.528-1.288-.916-2.088-1.164-.8-.248-1.632-.372-2.496-.372-.992 0-1.84.164-2.544.492-.704.328-1.28.752-1.728 1.272-.448.52-.776 1.092-.984 1.716-.208.624-.312 1.232-.312 1.824v2.4H6v2.016h2.448v5.256H6v2.304h11.4z"
              transform="translate(-112 -219) translate(112 219)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  usd: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <path
              d="M12.888 22.856v-1.728c.768-.08 1.484-.248 2.148-.504.664-.256 1.244-.604 1.74-1.044.496-.44.888-.968 1.176-1.584.288-.616.432-1.324.432-2.124 0-.816-.156-1.496-.468-2.04-.312-.544-.72-.996-1.224-1.356-.504-.36-1.08-.652-1.728-.876-.648-.224-1.308-.424-1.98-.6l-.096-.024v-4.8c.56 0 1.096.116 1.608.348.512.232.952.548 1.32.948l1.992-2.232c-.608-.544-1.34-.956-2.196-1.236-.856-.28-1.692-.42-2.508-.42h-.216V2h-1.296v1.608c-.672.064-1.32.224-1.944.48-.624.256-1.176.596-1.656 1.02-.48.424-.864.924-1.152 1.5-.288.576-.432 1.224-.432 1.944 0 .8.136 1.468.408 2.004.272.536.644.992 1.116 1.368.472.376 1.012.68 1.62.912.608.232 1.248.444 1.92.636l.12.024v5.064c-.672-.064-1.312-.24-1.92-.528-.608-.288-1.104-.704-1.488-1.248L6 19.016c.736.768 1.588 1.32 2.556 1.656.968.336 1.98.496 3.036.48v1.704h1.296zm-1.296-12.24c-.288-.128-.564-.244-.828-.348-.264-.104-.492-.236-.684-.396-.192-.16-.348-.352-.468-.576-.12-.224-.18-.52-.18-.888 0-.608.22-1.1.66-1.476.44-.376.94-.612 1.5-.708v4.392zm1.296 7.944v-4.68c.288.096.576.2.864.312.288.112.552.248.792.408.24.16.436.36.588.6.152.24.228.536.228.888s-.068.668-.204.948c-.136.28-.316.52-.54.72-.224.2-.484.368-.78.504-.296.136-.612.236-.948.3z"
              transform="translate(-40 -219) translate(40 219)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  eur: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <path
              d="M14.432 20.856c.864 0 1.668-.096 2.412-.288.744-.192 1.348-.44 1.812-.744l-.984-2.304c-.896.528-1.944.792-3.144.792-.608 0-1.168-.084-1.68-.252-.512-.168-.968-.396-1.368-.684-.4-.288-.736-.628-1.008-1.02s-.464-.812-.576-1.26h5.136l.648-2.064H9.536c-.016-.08-.028-.164-.036-.252-.008-.088-.012-.18-.012-.276V12c0-.448.024-.84.072-1.176h6.696l.672-2.064h-6.912c.16-.528.396-.992.708-1.392.312-.4.672-.736 1.08-1.008.408-.272.852-.48 1.332-.624.48-.144.96-.216 1.44-.216.592 0 1.16.056 1.704.168.544.112 1 .28 1.368.504l.912-2.4c-.432-.224-.988-.412-1.668-.564C16.212 3.076 15.488 3 14.72 3c-.96 0-1.852.136-2.676.408-.824.272-1.56.66-2.208 1.164-.648.504-1.204 1.108-1.668 1.812-.464.704-.816 1.496-1.056 2.376h-1.32l-.72 2.064H6.8c-.032.176-.052.364-.06.564-.008.2-.012.396-.012.588v.792c0 .096.008.184.024.264h-1.08L5 15.096h2.016c.192.784.48 1.524.864 2.22.384.696.88 1.308 1.488 1.836s1.332.944 2.172 1.248c.84.304 1.804.456 2.892.456z"
              transform="translate(-76 -219) translate(76 219)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  proposal: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <g>
              <g>
                <path
                  d="M20.41 8.41l-4.83-4.83c-.37-.37-.88-.58-1.41-.58H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.42zM7 7h7v2H7V7zm10 10H7v-2h10v2zm0-4H7v-2h10v2z"
                  transform="translate(-839 -425) translate(272 260) translate(559 161) translate(8 4)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  proposal2: {
    path: (
      <path
        d="M7.44667 1.83333L10.6667 5.05333V11.1667H1.33333V1.83333H7.44667ZM7.44667 0.5H1.33333C0.6 0.5 0 1.1 0 1.83333V11.1667C0 11.9 0.6 12.5 1.33333 12.5H10.6667C11.4 12.5 12 11.9 12 11.1667V5.05333C12 4.7 11.86 4.36 11.6067 4.11333L8.38667 0.893333C8.14 0.64 7.8 0.5 7.44667 0.5ZM2.66667 8.5H9.33333V9.83333H2.66667V8.5ZM2.66667 5.83333H9.33333V7.16667H2.66667V5.83333ZM2.66667 3.16667H7.33333V4.5H2.66667V3.16667Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 12 13',
  },
  assigned: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <g>
              <g>
                <path
                  d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-5 8h4V8l5 5-5 5v-3H7v-4z"
                  transform="translate(-296 -425) translate(272 260) translate(16 161) translate(8 4)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  commentRegular: {
    path: (
      <g fill="currentColor">
        <g fill="currentColor">
          <g>
            <g>
              <g>
                <path
                  d="M20.4 5H7.6C6.72 5 6 5.72 6 6.6V20l3.2-3.2h11.2c.88 0 1.6-.72 1.6-1.6V6.6c0-.88-.72-1.6-1.6-1.6z"
                  transform="translate(-1653.000000, -547.000000) translate(489.000000, 523.000000) translate(914.000000, 0.000000) translate(250.000000, 24.000000)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  arrowLongTail: {
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 0V2H11.59L0 13.59L1.41 15L13 3.41V10H15V0H5Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 15 15',
  },
  document: {
    path: (
      <path
        d="M4 14H12V16H4V14ZM4 10H12V12H4V10ZM10 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0ZM14 18H2V2H9V7H14V18Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 16 20',
  },
  // new sidebar icons
  dashboard: {
    path: (
      <path
        d="M16 2.51282V4.51282H12V2.51282H16ZM6 2.51282V8.51282H2V2.51282H6ZM16 10.5128V16.5128H12V10.5128H16ZM6 14.5128V16.5128H2V14.5128H6ZM18 0.512817H10V6.51282H18V0.512817ZM8 0.512817H0V10.5128H8V0.512817ZM18 8.51282H10V18.5128H18V8.51282ZM8 12.5128H0V18.5128H8V12.5128Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 18 19',
  },
  briefs: {
    path: (
      <path
        d="M4 14.5128H11V16.5128H4V14.5128ZM4 10.5128H14V12.5128H4V10.5128ZM4 6.51282H14V8.51282H4V6.51282ZM16 2.51282H11.82C11.4 1.35282 10.3 0.512817 9 0.512817C7.7 0.512817 6.6 1.35282 6.18 2.51282H2C1.86 2.51282 1.73 2.52282 1.6 2.55282C1.21 2.63282 0.86 2.83282 0.59 3.10282C0.41 3.28282 0.26 3.50282 0.16 3.74282C0.0600001 3.97282 0 4.23282 0 4.51282V18.5128C0 18.7828 0.0600001 19.0528 0.16 19.2928C0.26 19.5328 0.41 19.7428 0.59 19.9328C0.86 20.2028 1.21 20.4028 1.6 20.4828C1.73 20.5028 1.86 20.5128 2 20.5128H16C17.1 20.5128 18 19.6128 18 18.5128V4.51282C18 3.41282 17.1 2.51282 16 2.51282ZM9 2.26282C9.41 2.26282 9.75 2.60282 9.75 3.01282C9.75 3.42282 9.41 3.76282 9 3.76282C8.59 3.76282 8.25 3.42282 8.25 3.01282C8.25 2.60282 8.59 2.26282 9 2.26282ZM16 18.5128H2V4.51282H16V18.5128Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 18 21',
  },
  projects: {
    path: (
      <path
        d="M4 19.5128C4 20.0628 4.45 20.5128 5 20.5128H9C9.55 20.5128 10 20.0628 10 19.5128V18.5128H4V19.5128ZM7 0.512817C3.14 0.512817 0 3.65282 0 7.51282C0 9.89282 1.19 11.9828 3 13.2528V15.5128C3 16.0628 3.45 16.5128 4 16.5128H10C10.55 16.5128 11 16.0628 11 15.5128V13.2528C12.81 11.9828 14 9.89282 14 7.51282C14 3.65282 10.86 0.512817 7 0.512817ZM9.85 11.6128L9 12.2128V14.5128H5V12.2128L4.15 11.6128C2.8 10.6728 2 9.14282 2 7.51282C2 4.75282 4.24 2.51282 7 2.51282C9.76 2.51282 12 4.75282 12 7.51282C12 9.14282 11.2 10.6728 9.85 11.6128Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 14 21',
  },
  inbox: {
    path: (
      <path
        d="M20 2.51282C20 1.41282 19.1 0.512817 18 0.512817H2C0.9 0.512817 0 1.41282 0 2.51282V14.5128C0 15.6128 0.9 16.5128 2 16.5128H18C19.1 16.5128 20 15.6128 20 14.5128V2.51282ZM18 2.51282L10 7.50282L2 2.51282H18ZM18 14.5128H2V4.51282L10 9.51282L18 4.51282V14.5128Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 20 17',
  },
  resources: {
    path: (
      <path
        d="M18 2.51282H10L8 0.512817H2C0.9 0.512817 0.00999999 1.41282 0.00999999 2.51282L0 14.5128C0 15.6128 0.9 16.5128 2 16.5128H18C19.1 16.5128 20 15.6128 20 14.5128V4.51282C20 3.41282 19.1 2.51282 18 2.51282ZM18 14.5128H2V2.51282H7.17L9.17 4.51282H18V14.5128ZM16 8.51282H4V6.51282H16V8.51282ZM12 12.5128H4V10.5128H12V12.5128Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 20 17',
  },
  teams: {
    path: (
      <path
        d="M7 9.26282C4.66 9.26282 0 10.4328 0 12.7628V14.5128H14V12.7628C14 10.4328 9.34 9.26282 7 9.26282ZM2.34 12.5128C3.18 11.9328 5.21 11.2628 7 11.2628C8.79 11.2628 10.82 11.9328 11.66 12.5128H2.34ZM7 7.51282C8.93 7.51282 10.5 5.94282 10.5 4.01282C10.5 2.08282 8.93 0.512817 7 0.512817C5.07 0.512817 3.5 2.08282 3.5 4.01282C3.5 5.94282 5.07 7.51282 7 7.51282ZM7 2.51282C7.83 2.51282 8.5 3.18282 8.5 4.01282C8.5 4.84282 7.83 5.51282 7 5.51282C6.17 5.51282 5.5 4.84282 5.5 4.01282C5.5 3.18282 6.17 2.51282 7 2.51282ZM14.04 9.32282C15.2 10.1628 16 11.2828 16 12.7628V14.5128H20V12.7628C20 10.7428 16.5 9.59282 14.04 9.32282ZM13 7.51282C14.93 7.51282 16.5 5.94282 16.5 4.01282C16.5 2.08282 14.93 0.512817 13 0.512817C12.46 0.512817 11.96 0.642817 11.5 0.862817C12.13 1.75282 12.5 2.84282 12.5 4.01282C12.5 5.18282 12.13 6.27282 11.5 7.16282C11.96 7.38282 12.46 7.51282 13 7.51282Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 20 15',
  },
  users: {
    path: (
      <path
        d="M8 2.51282C9.1 2.51282 10 3.41282 10 4.51282C10 5.61282 9.1 6.51282 8 6.51282C6.9 6.51282 6 5.61282 6 4.51282C6 3.41282 6.9 2.51282 8 2.51282ZM8 12.5128C10.7 12.5128 13.8 13.8028 14 14.5128H2C2.23 13.7928 5.31 12.5128 8 12.5128ZM8 0.512817C5.79 0.512817 4 2.30282 4 4.51282C4 6.72282 5.79 8.51282 8 8.51282C10.21 8.51282 12 6.72282 12 4.51282C12 2.30282 10.21 0.512817 8 0.512817ZM8 10.5128C5.33 10.5128 0 11.8528 0 14.5128V16.5128H16V14.5128C16 11.8528 10.67 10.5128 8 10.5128Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 16 17',
  },
  settings: {
    path: (
      <path
        d="M17.4298 10.98C17.4698 10.66 17.4998 10.34 17.4998 10C17.4998 9.66 17.4698 9.34 17.4298 9.02L19.5398 7.37C19.7298 7.22 19.7798 6.95 19.6598 6.73L17.6598 3.27C17.5698 3.11 17.3998 3.02 17.2198 3.02C17.1598 3.02 17.0998 3.03 17.0498 3.05L14.5598 4.05C14.0398 3.65 13.4798 3.32 12.8698 3.07L12.4898 0.42C12.4598 0.18 12.2498 0 11.9998 0H7.99984C7.74984 0 7.53984 0.18 7.50984 0.42L7.12984 3.07C6.51984 3.32 5.95984 3.66 5.43984 4.05L2.94984 3.05C2.88984 3.03 2.82984 3.02 2.76984 3.02C2.59984 3.02 2.42984 3.11 2.33984 3.27L0.339839 6.73C0.209839 6.95 0.26984 7.22 0.45984 7.37L2.56984 9.02C2.52984 9.34 2.49984 9.67 2.49984 10C2.49984 10.33 2.52984 10.66 2.56984 10.98L0.45984 12.63C0.26984 12.78 0.219839 13.05 0.339839 13.27L2.33984 16.73C2.42984 16.89 2.59984 16.98 2.77984 16.98C2.83984 16.98 2.89984 16.97 2.94984 16.95L5.43984 15.95C5.95984 16.35 6.51984 16.68 7.12984 16.93L7.50984 19.58C7.53984 19.82 7.74984 20 7.99984 20H11.9998C12.2498 20 12.4598 19.82 12.4898 19.58L12.8698 16.93C13.4798 16.68 14.0398 16.34 14.5598 15.95L17.0498 16.95C17.1098 16.97 17.1698 16.98 17.2298 16.98C17.3998 16.98 17.5698 16.89 17.6598 16.73L19.6598 13.27C19.7798 13.05 19.7298 12.78 19.5398 12.63L17.4298 10.98ZM15.4498 9.27C15.4898 9.58 15.4998 9.79 15.4998 10C15.4998 10.21 15.4798 10.43 15.4498 10.73L15.3098 11.86L16.1998 12.56L17.2798 13.4L16.5798 14.61L15.3098 14.1L14.2698 13.68L13.3698 14.36C12.9398 14.68 12.5298 14.92 12.1198 15.09L11.0598 15.52L10.8998 16.65L10.6998 18H9.29984L9.10984 16.65L8.94984 15.52L7.88984 15.09C7.45984 14.91 7.05984 14.68 6.65984 14.38L5.74984 13.68L4.68984 14.11L3.41984 14.62L2.71984 13.41L3.79984 12.57L4.68984 11.87L4.54984 10.74C4.51984 10.43 4.49984 10.2 4.49984 10C4.49984 9.8 4.51984 9.57 4.54984 9.27L4.68984 8.14L3.79984 7.44L2.71984 6.6L3.41984 5.39L4.68984 5.9L5.72984 6.32L6.62984 5.64C7.05984 5.32 7.46984 5.08 7.87984 4.91L8.93984 4.48L9.09984 3.35L9.29984 2H10.6898L10.8798 3.35L11.0398 4.48L12.0998 4.91C12.5298 5.09 12.9298 5.32 13.3298 5.62L14.2398 6.32L15.2998 5.89L16.5698 5.38L17.2698 6.59L16.1998 7.44L15.3098 8.14L15.4498 9.27ZM9.99984 6C7.78984 6 5.99984 7.79 5.99984 10C5.99984 12.21 7.78984 14 9.99984 14C12.2098 14 13.9998 12.21 13.9998 10C13.9998 7.79 12.2098 6 9.99984 6ZM9.99984 12C8.89984 12 7.99984 11.1 7.99984 10C7.99984 8.9 8.89984 8 9.99984 8C11.0998 8 11.9998 8.9 11.9998 10C11.9998 11.1 11.0998 12 9.99984 12Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 20 20',
  },
  clock2: {
    path: (
      <path
        d="M20 4.71986L15.4 0.859863L14.11 2.38986L18.71 6.24986L20 4.71986ZM5.88 2.38986L4.6 0.859863L0 4.70986L1.29 6.23986L5.88 2.38986ZM10.5 6.99986H9V12.9999L13.75 15.8499L14.5 14.6199L10.5 12.2499V6.99986ZM10 2.99986C5.03 2.99986 1 7.02986 1 11.9999C1 16.9699 5.02 20.9999 10 20.9999C14.97 20.9999 19 16.9699 19 11.9999C19 7.02986 14.97 2.99986 10 2.99986ZM10 18.9999C6.13 18.9999 3 15.8699 3 11.9999C3 8.12986 6.13 4.99986 10 4.99986C13.87 4.99986 17 8.12986 17 11.9999C17 15.8699 13.87 18.9999 10 18.9999Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 20 21',
  },
  filterNew: {
    path: (
      <path
        d="M7 12H11V10H7V12ZM0 0V2H18V0H0ZM3 7H15V5H3V7Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 18 12',
  },
  dotsVertical: {
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 4 16',
  },
  duplicateNew: {
    path: (
      <path
        d="M12.2053 1V0.9H12.1053H2.15789C1.19206 0.9 0.4 1.67991 0.4 2.63636V14.0909V14.1909H0.5H2.15789H2.25789V14.0909V2.73636H12.1053H12.2053V2.63636V1ZM14.5921 4.17273H5.47368C4.50785 4.17273 3.71579 4.95263 3.71579 5.90909V17.3636C3.71579 18.3201 4.50785 19.1 5.47368 19.1H14.5921C15.5579 19.1 16.35 18.3201 16.35 17.3636V5.90909C16.35 4.95263 15.5579 4.17273 14.5921 4.17273ZM14.4921 17.2636H5.57368V6.00909H14.4921V17.2636Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
    ),
    viewBox: '0 0 17 20',
  },
  trashNew: {
    path: (
      <path
        d="M1.5 16C1.5 17.1 2.4 18 3.5 18H11.5C12.6 18 13.5 17.1 13.5 16V4H1.5V16ZM3.5 6H11.5V16H3.5V6ZM11 1L10 0H5L4 1H0.5V3H14.5V1H11Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 15 18',
  },
  archivedNew: {
    path: (
      <path
        d="M17.54 2.23L16.15 0.55C15.88 0.21 15.47 0 15 0H3C2.53 0 2.12 0.21 1.84 0.55L0.46 2.23C0.17 2.57 0 3.02 0 3.5V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V3.5C18 3.02 17.83 2.57 17.54 2.23ZM3.24 2H14.76L15.57 2.97H2.44L3.24 2ZM2 16V5H16V16H2ZM10.45 7H7.55V10H5L9 14L13 10H10.45V7Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 18 18',
  },
  success: {
    path: (
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 20 20',
  },
  sortAndSelect: {
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12H6V10H0V12ZM0 0V2H18V0H0ZM0 7H12V5H0V7Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 18 12',
  },
  infoFilled: {
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00016 0.833344C3.32016 0.833344 0.333496 3.82001 0.333496 7.50001C0.333496 11.18 3.32016 14.1667 7.00016 14.1667C10.6802 14.1667 13.6668 11.18 13.6668 7.50001C13.6668 3.82001 10.6802 0.833344 7.00016 0.833344ZM7.66683 10.8333H6.3335V6.83334H7.66683V10.8333ZM7.66683 5.50001H6.3335V4.16668H7.66683V5.50001Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 14 15',
  },
  calendar2: {
    path: (
      <path
        d="M4.25 9H6.25V11H4.25V9ZM18.25 4V18C18.25 19.1 17.35 20 16.25 20H2.25C1.14 20 0.25 19.1 0.25 18L0.26 4C0.26 2.9 1.14 2 2.25 2H3.25V0H5.25V2H13.25V0H15.25V2H16.25C17.35 2 18.25 2.9 18.25 4ZM2.25 6H16.25V4H2.25V6ZM16.25 18V8H2.25V18H16.25ZM12.25 11H14.25V9H12.25V11ZM8.25 11H10.25V9H8.25V11Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 19 20',
  },
  squares: {
    path: (
      <path
        d="M18 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM6 7H2V2H6V7ZM12 7H8V2H12V7ZM18 7H14V2H18V7ZM6 14H2V9H6V14ZM12 14H8V9H12V14ZM18 14H14V9H18V14Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 20 16',
  },
  pdf: {
    path: (
      <>
        <path
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
          fill="#2B231D"
        />
        <rect x="1" y="10" width="22" height="9" rx="1" fill="#FF6666" />
        <path
          d="M5.56894 12.044H7.40994C7.66661 12.044 7.90927 12.0673 8.13794 12.114C8.36661 12.1607 8.56494 12.2423 8.73294 12.359C8.90561 12.471 9.04094 12.625 9.13894 12.821C9.24161 13.0123 9.29294 13.255 9.29294 13.549C9.29294 13.8383 9.24628 14.081 9.15294 14.277C9.05961 14.473 8.93127 14.6293 8.76794 14.746C8.60461 14.8627 8.41094 14.9467 8.18694 14.998C7.96294 15.0447 7.72027 15.068 7.45894 15.068H6.66094V17H5.56894V12.044ZM6.66094 14.144H7.38894C7.48694 14.144 7.58027 14.1347 7.66894 14.116C7.76227 14.0973 7.84394 14.067 7.91394 14.025C7.98861 13.9783 8.04694 13.9177 8.08894 13.843C8.13561 13.7637 8.15894 13.6657 8.15894 13.549C8.15894 13.423 8.12861 13.3227 8.06794 13.248C8.01194 13.1687 7.93727 13.108 7.84394 13.066C7.75527 13.024 7.65494 12.9983 7.54294 12.989C7.43094 12.975 7.32361 12.968 7.22094 12.968H6.66094V14.144ZM9.97812 12.044H11.6161C12.0128 12.044 12.3885 12.0883 12.7431 12.177C13.1025 12.2657 13.4151 12.4103 13.6811 12.611C13.9471 12.807 14.1571 13.0637 14.3111 13.381C14.4698 13.6983 14.5491 14.0833 14.5491 14.536C14.5491 14.9373 14.4721 15.292 14.3181 15.6C14.1688 15.9033 13.9658 16.16 13.7091 16.37C13.4525 16.5753 13.1561 16.7317 12.8201 16.839C12.4841 16.9463 12.1318 17 11.7631 17H9.97812V12.044ZM11.0701 15.992H11.6371C11.8891 15.992 12.1225 15.9663 12.3371 15.915C12.5565 15.8637 12.7455 15.7797 12.9041 15.663C13.0628 15.5417 13.1865 15.3853 13.2751 15.194C13.3685 14.998 13.4151 14.76 13.4151 14.48C13.4151 14.2373 13.3685 14.0273 13.2751 13.85C13.1865 13.668 13.0651 13.5187 12.9111 13.402C12.7571 13.2853 12.5751 13.199 12.3651 13.143C12.1598 13.0823 11.9428 13.052 11.7141 13.052H11.0701V15.992ZM15.3316 12.044H18.6566V13.052H16.4236V14.06H18.4886V15.068H16.4236V17H15.3316V12.044Z"
          fill="white"
        />
      </>
    ),
    viewBox: '0 0 24 24',
  },
  doc: {
    path: (
      <>
        <path
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
          fill="#2B231D"
        />
        <rect x="1" y="10" width="22" height="9" rx="1" fill="#3366FF" />
        <path
          d="M4.54013 12.044H6.17813C6.5748 12.044 6.95047 12.0883 7.30513 12.177C7.66447 12.2657 7.97713 12.4103 8.24313 12.611C8.50913 12.807 8.71913 13.0637 8.87313 13.381C9.0318 13.6983 9.11113 14.0833 9.11113 14.536C9.11113 14.9373 9.03413 15.292 8.88013 15.6C8.7308 15.9033 8.5278 16.16 8.27113 16.37C8.01447 16.5753 7.71813 16.7317 7.38213 16.839C7.04613 16.9463 6.6938 17 6.32513 17H4.54013V12.044ZM5.63213 15.992H6.19913C6.45113 15.992 6.68447 15.9663 6.89913 15.915C7.11847 15.8637 7.30747 15.7797 7.46613 15.663C7.6248 15.5417 7.74847 15.3853 7.83713 15.194C7.93047 14.998 7.97713 14.76 7.97713 14.48C7.97713 14.2373 7.93047 14.0273 7.83713 13.85C7.74847 13.668 7.62713 13.5187 7.47313 13.402C7.31913 13.2853 7.13713 13.199 6.92713 13.143C6.7218 13.0823 6.5048 13.052 6.27613 13.052H5.63213V15.992ZM9.58566 14.522C9.58566 14.1253 9.65099 13.766 9.78166 13.444C9.91699 13.122 10.1037 12.849 10.3417 12.625C10.5797 12.3963 10.862 12.2213 11.1887 12.1C11.5153 11.9787 11.8723 11.918 12.2597 11.918C12.647 11.918 13.004 11.9787 13.3307 12.1C13.6573 12.2213 13.9397 12.3963 14.1777 12.625C14.4157 12.849 14.6 13.122 14.7307 13.444C14.866 13.766 14.9337 14.1253 14.9337 14.522C14.9337 14.9187 14.866 15.278 14.7307 15.6C14.6 15.922 14.4157 16.1973 14.1777 16.426C13.9397 16.65 13.6573 16.8227 13.3307 16.944C13.004 17.0653 12.647 17.126 12.2597 17.126C11.8723 17.126 11.5153 17.0653 11.1887 16.944C10.862 16.8227 10.5797 16.65 10.3417 16.426C10.1037 16.1973 9.91699 15.922 9.78166 15.6C9.65099 15.278 9.58566 14.9187 9.58566 14.522ZM10.7197 14.522C10.7197 14.7553 10.7547 14.97 10.8247 15.166C10.8993 15.3573 11.0043 15.5253 11.1397 15.67C11.275 15.81 11.436 15.9197 11.6227 15.999C11.814 16.0783 12.0263 16.118 12.2597 16.118C12.493 16.118 12.703 16.0783 12.8897 15.999C13.081 15.9197 13.2443 15.81 13.3797 15.67C13.515 15.5253 13.6177 15.3573 13.6877 15.166C13.7623 14.97 13.7997 14.7553 13.7997 14.522C13.7997 14.2933 13.7623 14.081 13.6877 13.885C13.6177 13.689 13.515 13.521 13.3797 13.381C13.2443 13.2363 13.081 13.1243 12.8897 13.045C12.703 12.9657 12.493 12.926 12.2597 12.926C12.0263 12.926 11.814 12.9657 11.6227 13.045C11.436 13.1243 11.275 13.2363 11.1397 13.381C11.0043 13.521 10.8993 13.689 10.8247 13.885C10.7547 14.081 10.7197 14.2933 10.7197 14.522ZM18.9169 13.332C18.8095 13.2013 18.6765 13.101 18.5179 13.031C18.3639 12.961 18.1842 12.926 17.9789 12.926C17.7735 12.926 17.5822 12.9657 17.4049 13.045C17.2322 13.1243 17.0805 13.2363 16.9499 13.381C16.8239 13.521 16.7235 13.689 16.6489 13.885C16.5789 14.081 16.5439 14.2933 16.5439 14.522C16.5439 14.7553 16.5789 14.97 16.6489 15.166C16.7235 15.3573 16.8239 15.5253 16.9499 15.67C17.0759 15.81 17.2229 15.9197 17.3909 15.999C17.5635 16.0783 17.7479 16.118 17.9439 16.118C18.1679 16.118 18.3662 16.0713 18.5389 15.978C18.7115 15.8847 18.8539 15.754 18.9659 15.586L19.8759 16.265C19.6659 16.559 19.3999 16.776 19.0779 16.916C18.7559 17.056 18.4245 17.126 18.0839 17.126C17.6965 17.126 17.3395 17.0653 17.0129 16.944C16.6862 16.8227 16.4039 16.65 16.1659 16.426C15.9279 16.1973 15.7412 15.922 15.6059 15.6C15.4752 15.278 15.4099 14.9187 15.4099 14.522C15.4099 14.1253 15.4752 13.766 15.6059 13.444C15.7412 13.122 15.9279 12.849 16.1659 12.625C16.4039 12.3963 16.6862 12.2213 17.0129 12.1C17.3395 11.9787 17.6965 11.918 18.0839 11.918C18.2239 11.918 18.3685 11.932 18.5179 11.96C18.6719 11.9833 18.8212 12.023 18.9659 12.079C19.1152 12.135 19.2575 12.2097 19.3929 12.303C19.5282 12.3963 19.6495 12.5107 19.7569 12.646L18.9169 13.332Z"
          fill="white"
        />
      </>
    ),
    viewBox: '0 0 24 24',
  },
  docx: {
    path: (
      <>
        <path
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
          fill="#2B231D"
        />
        <rect x="1" y="10" width="22" height="9" rx="1" fill="#3366FF" />
        <path
          d="M2.01425 12.044H3.65225C4.04892 12.044 4.42459 12.0883 4.77925 12.177C5.13859 12.2657 5.45125 12.4103 5.71725 12.611C5.98325 12.807 6.19325 13.0637 6.34725 13.381C6.50592 13.6983 6.58525 14.0833 6.58525 14.536C6.58525 14.9373 6.50825 15.292 6.35425 15.6C6.20492 15.9033 6.00192 16.16 5.74525 16.37C5.48859 16.5753 5.19225 16.7317 4.85625 16.839C4.52025 16.9463 4.16792 17 3.79925 17H2.01425V12.044ZM3.10625 15.992H3.67325C3.92525 15.992 4.15859 15.9663 4.37325 15.915C4.59259 15.8637 4.78159 15.7797 4.94025 15.663C5.09892 15.5417 5.22259 15.3853 5.31125 15.194C5.40459 14.998 5.45125 14.76 5.45125 14.48C5.45125 14.2373 5.40459 14.0273 5.31125 13.85C5.22259 13.668 5.10125 13.5187 4.94725 13.402C4.79325 13.2853 4.61125 13.199 4.40125 13.143C4.19592 13.0823 3.97892 13.052 3.75025 13.052H3.10625V15.992ZM7.05978 14.522C7.05978 14.1253 7.12511 13.766 7.25578 13.444C7.39111 13.122 7.57778 12.849 7.81578 12.625C8.05378 12.3963 8.33611 12.2213 8.66278 12.1C8.98944 11.9787 9.34644 11.918 9.73378 11.918C10.1211 11.918 10.4781 11.9787 10.8048 12.1C11.1314 12.2213 11.4138 12.3963 11.6518 12.625C11.8898 12.849 12.0741 13.122 12.2048 13.444C12.3401 13.766 12.4078 14.1253 12.4078 14.522C12.4078 14.9187 12.3401 15.278 12.2048 15.6C12.0741 15.922 11.8898 16.1973 11.6518 16.426C11.4138 16.65 11.1314 16.8227 10.8048 16.944C10.4781 17.0653 10.1211 17.126 9.73378 17.126C9.34644 17.126 8.98944 17.0653 8.66278 16.944C8.33611 16.8227 8.05378 16.65 7.81578 16.426C7.57778 16.1973 7.39111 15.922 7.25578 15.6C7.12511 15.278 7.05978 14.9187 7.05978 14.522ZM8.19378 14.522C8.19378 14.7553 8.22878 14.97 8.29878 15.166C8.37344 15.3573 8.47844 15.5253 8.61378 15.67C8.74911 15.81 8.91011 15.9197 9.09678 15.999C9.28811 16.0783 9.50044 16.118 9.73378 16.118C9.96711 16.118 10.1771 16.0783 10.3638 15.999C10.5551 15.9197 10.7184 15.81 10.8538 15.67C10.9891 15.5253 11.0918 15.3573 11.1618 15.166C11.2364 14.97 11.2738 14.7553 11.2738 14.522C11.2738 14.2933 11.2364 14.081 11.1618 13.885C11.0918 13.689 10.9891 13.521 10.8538 13.381C10.7184 13.2363 10.5551 13.1243 10.3638 13.045C10.1771 12.9657 9.96711 12.926 9.73378 12.926C9.50044 12.926 9.28811 12.9657 9.09678 13.045C8.91011 13.1243 8.74911 13.2363 8.61378 13.381C8.47844 13.521 8.37344 13.689 8.29878 13.885C8.22878 14.081 8.19378 14.2933 8.19378 14.522ZM16.391 13.332C16.2837 13.2013 16.1507 13.101 15.992 13.031C15.838 12.961 15.6583 12.926 15.453 12.926C15.2477 12.926 15.0563 12.9657 14.879 13.045C14.7063 13.1243 14.5547 13.2363 14.424 13.381C14.298 13.521 14.1977 13.689 14.123 13.885C14.053 14.081 14.018 14.2933 14.018 14.522C14.018 14.7553 14.053 14.97 14.123 15.166C14.1977 15.3573 14.298 15.5253 14.424 15.67C14.55 15.81 14.697 15.9197 14.865 15.999C15.0377 16.0783 15.222 16.118 15.418 16.118C15.642 16.118 15.8403 16.0713 16.013 15.978C16.1857 15.8847 16.328 15.754 16.44 15.586L17.35 16.265C17.14 16.559 16.874 16.776 16.552 16.916C16.23 17.056 15.8987 17.126 15.558 17.126C15.1707 17.126 14.8137 17.0653 14.487 16.944C14.1603 16.8227 13.878 16.65 13.64 16.426C13.402 16.1973 13.2153 15.922 13.08 15.6C12.9493 15.278 12.884 14.9187 12.884 14.522C12.884 14.1253 12.9493 13.766 13.08 13.444C13.2153 13.122 13.402 12.849 13.64 12.625C13.878 12.3963 14.1603 12.2213 14.487 12.1C14.8137 11.9787 15.1707 11.918 15.558 11.918C15.698 11.918 15.8427 11.932 15.992 11.96C16.146 11.9833 16.2953 12.023 16.44 12.079C16.5893 12.135 16.7317 12.2097 16.867 12.303C17.0023 12.3963 17.1237 12.5107 17.231 12.646L16.391 13.332ZM19.174 14.41L17.536 12.044H18.908L19.965 13.78L20.98 12.044H22.303L20.7 14.389L22.492 17H21.12L19.909 15.005L18.733 17H17.438L19.174 14.41Z"
          fill="white"
        />
      </>
    ),
    viewBox: '0 0 24 24',
  },
  csv: {
    path: (
      <>
        <path
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
          fill="#2B231D"
        />
        <rect x="1" y="10" width="22" height="9" rx="1" fill="#3366FF" />
        <path
          d="M8.87488 13.332C8.76755 13.2013 8.63455 13.101 8.47588 13.031C8.32188 12.961 8.14222 12.926 7.93688 12.926C7.73155 12.926 7.54022 12.9657 7.36288 13.045C7.19022 13.1243 7.03855 13.2363 6.90788 13.381C6.78188 13.521 6.68155 13.689 6.60688 13.885C6.53688 14.081 6.50188 14.2933 6.50188 14.522C6.50188 14.7553 6.53688 14.97 6.60688 15.166C6.68155 15.3573 6.78188 15.5253 6.90788 15.67C7.03388 15.81 7.18088 15.9197 7.34888 15.999C7.52155 16.0783 7.70588 16.118 7.90188 16.118C8.12588 16.118 8.32422 16.0713 8.49688 15.978C8.66955 15.8847 8.81188 15.754 8.92388 15.586L9.83388 16.265C9.62388 16.559 9.35788 16.776 9.03588 16.916C8.71388 17.056 8.38255 17.126 8.04188 17.126C7.65455 17.126 7.29755 17.0653 6.97088 16.944C6.64422 16.8227 6.36188 16.65 6.12388 16.426C5.88588 16.1973 5.69922 15.922 5.56388 15.6C5.43322 15.278 5.36788 14.9187 5.36788 14.522C5.36788 14.1253 5.43322 13.766 5.56388 13.444C5.69922 13.122 5.88588 12.849 6.12388 12.625C6.36188 12.3963 6.64422 12.2213 6.97088 12.1C7.29755 11.9787 7.65455 11.918 8.04188 11.918C8.18188 11.918 8.32655 11.932 8.47588 11.96C8.62988 11.9833 8.77922 12.023 8.92388 12.079C9.07322 12.135 9.21555 12.2097 9.35088 12.303C9.48622 12.3963 9.60755 12.5107 9.71488 12.646L8.87488 13.332ZM12.8759 13.255C12.7872 13.143 12.6659 13.0613 12.5119 13.01C12.3625 12.954 12.2202 12.926 12.0849 12.926C12.0055 12.926 11.9239 12.9353 11.8399 12.954C11.7559 12.9727 11.6765 13.003 11.6019 13.045C11.5272 13.0823 11.4665 13.1337 11.4199 13.199C11.3732 13.2643 11.3499 13.3437 11.3499 13.437C11.3499 13.5863 11.4059 13.7007 11.5179 13.78C11.6299 13.8593 11.7699 13.927 11.9379 13.983C12.1105 14.039 12.2949 14.095 12.4909 14.151C12.6869 14.207 12.8689 14.2863 13.0369 14.389C13.2095 14.4917 13.3519 14.6293 13.4639 14.802C13.5759 14.9747 13.6319 15.2057 13.6319 15.495C13.6319 15.7703 13.5805 16.0107 13.4779 16.216C13.3752 16.4213 13.2352 16.5917 13.0579 16.727C12.8852 16.8623 12.6822 16.9627 12.4489 17.028C12.2202 17.0933 11.9775 17.126 11.7209 17.126C11.3989 17.126 11.1002 17.077 10.8249 16.979C10.5495 16.881 10.2929 16.7223 10.0549 16.503L10.8319 15.649C10.9439 15.7983 11.0839 15.915 11.2519 15.999C11.4245 16.0783 11.6019 16.118 11.7839 16.118C11.8725 16.118 11.9612 16.1087 12.0499 16.09C12.1432 16.0667 12.2249 16.034 12.2949 15.992C12.3695 15.95 12.4279 15.8963 12.4699 15.831C12.5165 15.7657 12.5399 15.6887 12.5399 15.6C12.5399 15.4507 12.4815 15.334 12.3649 15.25C12.2529 15.1613 12.1105 15.0867 11.9379 15.026C11.7652 14.9653 11.5785 14.9047 11.3779 14.844C11.1772 14.7833 10.9905 14.7017 10.8179 14.599C10.6452 14.4963 10.5005 14.361 10.3839 14.193C10.2719 14.025 10.2159 13.8033 10.2159 13.528C10.2159 13.262 10.2672 13.0287 10.3699 12.828C10.4772 12.6273 10.6172 12.4593 10.7899 12.324C10.9672 12.1887 11.1702 12.0883 11.3989 12.023C11.6275 11.953 11.8632 11.918 12.1059 11.918C12.3859 11.918 12.6565 11.9577 12.9179 12.037C13.1792 12.1163 13.4149 12.2493 13.6249 12.436L12.8759 13.255ZM13.9554 12.044H15.2014L16.4264 15.292H16.4404L17.6864 12.044H18.8554L16.8114 17H15.9364L13.9554 12.044Z"
          fill="white"
        />
      </>
    ),
    viewBox: '0 0 24 24',
  },
  xls: {
    path: (
      <>
        <path
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
          fill="#2B231D"
        />
        <rect x="1" y="10" width="22" height="9" rx="1" fill="#7CCC33" />
        <path
          d="M7.32047 14.41L5.68247 12.044H7.05447L8.11147 13.78L9.12647 12.044H10.4495L8.84647 14.389L10.6385 17H9.26647L8.05547 15.005L6.87947 17H5.58447L7.32047 14.41ZM11.1822 12.044H12.2742V15.992H14.2972V17H11.1822V12.044ZM17.35 13.255C17.2613 13.143 17.14 13.0613 16.986 13.01C16.8367 12.954 16.6943 12.926 16.559 12.926C16.4797 12.926 16.398 12.9353 16.314 12.954C16.23 12.9727 16.1507 13.003 16.076 13.045C16.0013 13.0823 15.9407 13.1337 15.894 13.199C15.8473 13.2643 15.824 13.3437 15.824 13.437C15.824 13.5863 15.88 13.7007 15.992 13.78C16.104 13.8593 16.244 13.927 16.412 13.983C16.5847 14.039 16.769 14.095 16.965 14.151C17.161 14.207 17.343 14.2863 17.511 14.389C17.6837 14.4917 17.826 14.6293 17.938 14.802C18.05 14.9747 18.106 15.2057 18.106 15.495C18.106 15.7703 18.0547 16.0107 17.952 16.216C17.8493 16.4213 17.7093 16.5917 17.532 16.727C17.3593 16.8623 17.1563 16.9627 16.923 17.028C16.6943 17.0933 16.4517 17.126 16.195 17.126C15.873 17.126 15.5743 17.077 15.299 16.979C15.0237 16.881 14.767 16.7223 14.529 16.503L15.306 15.649C15.418 15.7983 15.558 15.915 15.726 15.999C15.8987 16.0783 16.076 16.118 16.258 16.118C16.3467 16.118 16.4353 16.1087 16.524 16.09C16.6173 16.0667 16.699 16.034 16.769 15.992C16.8437 15.95 16.902 15.8963 16.944 15.831C16.9907 15.7657 17.014 15.6887 17.014 15.6C17.014 15.4507 16.9557 15.334 16.839 15.25C16.727 15.1613 16.5847 15.0867 16.412 15.026C16.2393 14.9653 16.0527 14.9047 15.852 14.844C15.6513 14.7833 15.4647 14.7017 15.292 14.599C15.1193 14.4963 14.9747 14.361 14.858 14.193C14.746 14.025 14.69 13.8033 14.69 13.528C14.69 13.262 14.7413 13.0287 14.844 12.828C14.9513 12.6273 15.0913 12.4593 15.264 12.324C15.4413 12.1887 15.6443 12.0883 15.873 12.023C16.1017 11.953 16.3373 11.918 16.58 11.918C16.86 11.918 17.1307 11.9577 17.392 12.037C17.6533 12.1163 17.889 12.2493 18.099 12.436L17.35 13.255Z"
          fill="white"
        />
      </>
    ),
    viewBox: '0 0 24 24',
  },
  xlsx: {
    path: (
      <>
        <path
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
          fill="#2B231D"
        />
        <rect x="1" y="10" width="22" height="9" rx="1" fill="#7CCC33" />
        <path
          d="M4.79459 14.41L3.15659 12.044H4.52859L5.58559 13.78L6.60059 12.044H7.92359L6.32059 14.389L8.11259 17H6.74059L5.52959 15.005L4.35359 17H3.05859L4.79459 14.41ZM8.65635 12.044H9.74835V15.992H11.7714V17H8.65635V12.044ZM14.8241 13.255C14.7355 13.143 14.6141 13.0613 14.4601 13.01C14.3108 12.954 14.1685 12.926 14.0331 12.926C13.9538 12.926 13.8721 12.9353 13.7881 12.954C13.7041 12.9727 13.6248 13.003 13.5501 13.045C13.4755 13.0823 13.4148 13.1337 13.3681 13.199C13.3215 13.2643 13.2981 13.3437 13.2981 13.437C13.2981 13.5863 13.3541 13.7007 13.4661 13.78C13.5781 13.8593 13.7181 13.927 13.8861 13.983C14.0588 14.039 14.2431 14.095 14.4391 14.151C14.6351 14.207 14.8171 14.2863 14.9851 14.389C15.1578 14.4917 15.3001 14.6293 15.4121 14.802C15.5241 14.9747 15.5801 15.2057 15.5801 15.495C15.5801 15.7703 15.5288 16.0107 15.4261 16.216C15.3235 16.4213 15.1835 16.5917 15.0061 16.727C14.8335 16.8623 14.6305 16.9627 14.3971 17.028C14.1685 17.0933 13.9258 17.126 13.6691 17.126C13.3471 17.126 13.0485 17.077 12.7731 16.979C12.4978 16.881 12.2411 16.7223 12.0031 16.503L12.7801 15.649C12.8921 15.7983 13.0321 15.915 13.2001 15.999C13.3728 16.0783 13.5501 16.118 13.7321 16.118C13.8208 16.118 13.9095 16.1087 13.9981 16.09C14.0915 16.0667 14.1731 16.034 14.2431 15.992C14.3178 15.95 14.3761 15.8963 14.4181 15.831C14.4648 15.7657 14.4881 15.6887 14.4881 15.6C14.4881 15.4507 14.4298 15.334 14.3131 15.25C14.2011 15.1613 14.0588 15.0867 13.8861 15.026C13.7135 14.9653 13.5268 14.9047 13.3261 14.844C13.1255 14.7833 12.9388 14.7017 12.7661 14.599C12.5935 14.4963 12.4488 14.361 12.3321 14.193C12.2201 14.025 12.1641 13.8033 12.1641 13.528C12.1641 13.262 12.2155 13.0287 12.3181 12.828C12.4255 12.6273 12.5655 12.4593 12.7381 12.324C12.9155 12.1887 13.1185 12.0883 13.3471 12.023C13.5758 11.953 13.8115 11.918 14.0541 11.918C14.3341 11.918 14.6048 11.9577 14.8661 12.037C15.1275 12.1163 15.3631 12.2493 15.5731 12.436L14.8241 13.255ZM17.6256 14.41L15.9876 12.044H17.3596L18.4166 13.78L19.4316 12.044H20.7546L19.1516 14.389L20.9436 17H19.5716L18.3606 15.005L17.1846 17H15.8896L17.6256 14.41Z"
          fill="white"
        />
      </>
    ),
    viewBox: '0 0 24 24',
  },
  png: {
    path: (
      <>
        <path
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
          fill="#2B231D"
        />
        <rect x="1" y="10" width="22" height="9" rx="1" fill="#7B61FF" />
        <path
          d="M4.72129 12.044H6.56229C6.81895 12.044 7.06162 12.0673 7.29029 12.114C7.51895 12.1607 7.71729 12.2423 7.88529 12.359C8.05795 12.471 8.19329 12.625 8.29129 12.821C8.39395 13.0123 8.44529 13.255 8.44529 13.549C8.44529 13.8383 8.39862 14.081 8.30529 14.277C8.21195 14.473 8.08362 14.6293 7.92029 14.746C7.75695 14.8627 7.56329 14.9467 7.33929 14.998C7.11529 15.0447 6.87262 15.068 6.61129 15.068H5.81329V17H4.72129V12.044ZM5.81329 14.144H6.54129C6.63929 14.144 6.73262 14.1347 6.82129 14.116C6.91462 14.0973 6.99629 14.067 7.06629 14.025C7.14095 13.9783 7.19929 13.9177 7.24129 13.843C7.28795 13.7637 7.31129 13.6657 7.31129 13.549C7.31129 13.423 7.28095 13.3227 7.22029 13.248C7.16429 13.1687 7.08962 13.108 6.99629 13.066C6.90762 13.024 6.80729 12.9983 6.69529 12.989C6.58329 12.975 6.47595 12.968 6.37329 12.968H5.81329V14.144ZM9.13046 12.044H10.6145L12.7215 15.488H12.7355V12.044H13.8275V17H12.3995L10.2365 13.472H10.2225V17H9.13046V12.044ZM19.3255 16.65C19.0035 16.818 18.6675 16.9393 18.3175 17.014C17.9675 17.0887 17.6105 17.126 17.2465 17.126C16.8591 17.126 16.5021 17.0653 16.1755 16.944C15.8488 16.8227 15.5665 16.65 15.3285 16.426C15.0905 16.1973 14.9038 15.922 14.7685 15.6C14.6378 15.278 14.5725 14.9187 14.5725 14.522C14.5725 14.1253 14.6378 13.766 14.7685 13.444C14.9038 13.122 15.0905 12.849 15.3285 12.625C15.5665 12.3963 15.8488 12.2213 16.1755 12.1C16.5021 11.9787 16.8591 11.918 17.2465 11.918C17.6431 11.918 18.0071 11.967 18.3385 12.065C18.6745 12.1583 18.9685 12.3217 19.2205 12.555L18.4505 13.395C18.3011 13.241 18.1331 13.1243 17.9465 13.045C17.7598 12.9657 17.5265 12.926 17.2465 12.926C17.0131 12.926 16.8008 12.9657 16.6095 13.045C16.4228 13.1243 16.2618 13.2363 16.1265 13.381C15.9911 13.521 15.8861 13.689 15.8115 13.885C15.7415 14.081 15.7065 14.2933 15.7065 14.522C15.7065 14.7553 15.7415 14.97 15.8115 15.166C15.8861 15.3573 15.9911 15.5253 16.1265 15.67C16.2618 15.81 16.4228 15.9197 16.6095 15.999C16.8008 16.0783 17.0131 16.118 17.2465 16.118C17.4845 16.118 17.6898 16.0923 17.8625 16.041C18.0351 15.985 18.1728 15.929 18.2755 15.873V15.068H17.3865V14.06H19.3255V16.65Z"
          fill="white"
        />
      </>
    ),
    viewBox: '0 0 24 24',
  },
  jpg: {
    path: (
      <>
        <path
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
          fill="#2B231D"
        />
        <rect x="1" y="10" width="22" height="9" rx="1" fill="#47B5BD" />
        <path
          d="M8.38729 15.341C8.38729 15.5697 8.36629 15.7913 8.32429 16.006C8.28696 16.2207 8.21229 16.412 8.10029 16.58C7.98829 16.7433 7.82729 16.8763 7.61729 16.979C7.41196 17.077 7.14129 17.126 6.80529 17.126C6.41329 17.126 6.08196 17.0327 5.81129 16.846C5.54062 16.6593 5.36562 16.3677 5.28629 15.971L6.28729 15.726C6.30129 15.8473 6.35496 15.95 6.44829 16.034C6.54629 16.118 6.65596 16.16 6.77729 16.16C6.90329 16.16 7.00129 16.1297 7.07129 16.069C7.14129 16.0037 7.19262 15.9243 7.22529 15.831C7.25796 15.7377 7.27662 15.6373 7.28129 15.53C7.29062 15.418 7.29529 15.3153 7.29529 15.222V12.044H8.38729V15.341ZM9.32529 12.044H11.1663C11.423 12.044 11.6656 12.0673 11.8943 12.114C12.123 12.1607 12.3213 12.2423 12.4893 12.359C12.662 12.471 12.7973 12.625 12.8953 12.821C12.998 13.0123 13.0493 13.255 13.0493 13.549C13.0493 13.8383 13.0026 14.081 12.9093 14.277C12.816 14.473 12.6876 14.6293 12.5243 14.746C12.361 14.8627 12.1673 14.9467 11.9433 14.998C11.7193 15.0447 11.4766 15.068 11.2153 15.068H10.4173V17H9.32529V12.044ZM10.4173 14.144H11.1453C11.2433 14.144 11.3366 14.1347 11.4253 14.116C11.5186 14.0973 11.6003 14.067 11.6703 14.025C11.745 13.9783 11.8033 13.9177 11.8453 13.843C11.892 13.7637 11.9153 13.6657 11.9153 13.549C11.9153 13.423 11.885 13.3227 11.8243 13.248C11.7683 13.1687 11.6936 13.108 11.6003 13.066C11.5116 13.024 11.4113 12.9983 11.2993 12.989C11.1873 12.975 11.08 12.968 10.9773 12.968H10.4173V14.144ZM18.2215 16.65C17.8995 16.818 17.5635 16.9393 17.2135 17.014C16.8635 17.0887 16.5065 17.126 16.1425 17.126C15.7551 17.126 15.3981 17.0653 15.0715 16.944C14.7448 16.8227 14.4625 16.65 14.2245 16.426C13.9865 16.1973 13.7998 15.922 13.6645 15.6C13.5338 15.278 13.4685 14.9187 13.4685 14.522C13.4685 14.1253 13.5338 13.766 13.6645 13.444C13.7998 13.122 13.9865 12.849 14.2245 12.625C14.4625 12.3963 14.7448 12.2213 15.0715 12.1C15.3981 11.9787 15.7551 11.918 16.1425 11.918C16.5391 11.918 16.9031 11.967 17.2345 12.065C17.5705 12.1583 17.8645 12.3217 18.1165 12.555L17.3465 13.395C17.1971 13.241 17.0291 13.1243 16.8425 13.045C16.6558 12.9657 16.4225 12.926 16.1425 12.926C15.9091 12.926 15.6968 12.9657 15.5055 13.045C15.3188 13.1243 15.1578 13.2363 15.0225 13.381C14.8871 13.521 14.7821 13.689 14.7075 13.885C14.6375 14.081 14.6025 14.2933 14.6025 14.522C14.6025 14.7553 14.6375 14.97 14.7075 15.166C14.7821 15.3573 14.8871 15.5253 15.0225 15.67C15.1578 15.81 15.3188 15.9197 15.5055 15.999C15.6968 16.0783 15.9091 16.118 16.1425 16.118C16.3805 16.118 16.5858 16.0923 16.7585 16.041C16.9311 15.985 17.0688 15.929 17.1715 15.873V15.068H16.2825V14.06H18.2215V16.65Z"
          fill="white"
        />
      </>
    ),
    viewBox: '0 0 24 24',
  },
  commentOutline: {
    path: (
      <path
        d="M16.2 0H1.8C0.81 0 0 0.81 0 1.8V18L3.6 14.4H16.2C17.19 14.4 18 13.59 18 12.6V1.8C18 0.81 17.19 0 16.2 0ZM16.2 12.6H3.6L1.8 14.4V1.8H16.2V12.6Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 18 18',
  },
  add: {
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 14 14',
  },
  search: {
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 18 18',
  },
  bell: {
    path: (
      <path
        d="M8 20C9.1 20 10 19.1 10 18H6C6 19.1 6.9 20 8 20ZM14 14V9C14 5.93 12.37 3.36 9.5 2.68V2C9.5 1.17 8.83 0.5 8 0.5C7.17 0.5 6.5 1.17 6.5 2V2.68C3.64 3.36 2 5.92 2 9V14L0 16V17H16V16L14 14ZM12 15H4V9C4 6.52 5.51 4.5 8 4.5C10.49 4.5 12 6.52 12 9V15Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 16 20',
  },
  chevronDown: {
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.41 0.59L0 2L6 8L12 2L10.59 0.59L6 5.17L1.41 0.59Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 12 8',
  },
  error: {
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 20 20',
  },
  info: {
    path: (
      <path
        d="M6.99967 0.833496C3.31967 0.833496 0.333008 3.82016 0.333008 7.50016C0.333008 11.1802 3.31967 14.1668 6.99967 14.1668C10.6797 14.1668 13.6663 11.1802 13.6663 7.50016C13.6663 3.82016 10.6797 0.833496 6.99967 0.833496ZM7.66634 10.8335H6.33301V6.8335H7.66634V10.8335ZM7.66634 5.50016H6.33301V4.16683H7.66634V5.50016Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 14 15',
  },
  infoOutline: {
    path: (
      <path
        d="M6.33337 3.66665H7.66671V4.99998H6.33337V3.66665ZM6.33337 6.33331H7.66671V10.3333H6.33337V6.33331ZM7.00004 0.333313C3.32004 0.333313 0.333374 3.31998 0.333374 6.99998C0.333374 10.68 3.32004 13.6666 7.00004 13.6666C10.68 13.6666 13.6667 10.68 13.6667 6.99998C13.6667 3.31998 10.68 0.333313 7.00004 0.333313ZM7.00004 12.3333C4.06004 12.3333 1.66671 9.93998 1.66671 6.99998C1.66671 4.05998 4.06004 1.66665 7.00004 1.66665C9.94004 1.66665 12.3334 4.05998 12.3334 6.99998C12.3334 9.93998 9.94004 12.3333 7.00004 12.3333Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 14 14',
  },
  warning: {
    path: (
      <path
        d="M0.73804 14.9979C-0.0338891 16.3313 0.92823 18 2.46889 18H17.5311C19.0718 18 20.0339 16.3313 19.262 14.9979L11.7309 1.98965C10.9605 0.659081 9.03948 0.659085 8.26915 1.98965L0.73804 14.9979ZM11 14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14C9 13.4477 9.44771 13 10 13C10.5523 13 11 13.4477 11 14ZM11 10C11 10.5523 10.5523 11 10 11C9.44771 11 9 10.5523 9 10V8C9 7.44771 9.44771 7 10 7C10.5523 7 11 7.44771 11 8V10Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 20 18',
  },
  camera: {
    path: (
      <path
        d="M24.24 4L27.9 8H36V32H4V8H12.1L15.76 4H24.24ZM26 0H14L10.34 4H4C1.8 4 0 5.8 0 8V32C0 34.2 1.8 36 4 36H36C38.2 36 40 34.2 40 32V8C40 5.8 38.2 4 36 4H29.66L26 0ZM20 14C23.3 14 26 16.7 26 20C26 23.3 23.3 26 20 26C16.7 26 14 23.3 14 20C14 16.7 16.7 14 20 14ZM20 10C14.48 10 10 14.48 10 20C10 25.52 14.48 30 20 30C25.52 30 30 25.52 30 20C30 14.48 25.52 10 20 10Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 40 36',
  },
  tick: {
    path: (
      <path
        d="M10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM8.5 15L3.5 10L4.91 8.59L8.5 12.17L16.09 4.58L17.5 6L8.5 15Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 21 20',
  },
  upload: {
    path: (
      <path
        d="M0 11L4 11V17H10V11H14L7 4L0 11ZM14 2V0H0V2L14 2Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 14 17',
  },
  circleDots: {
    path: (
      <path
        d="M10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10C0 4.48 4.48 0 10 0ZM10 2C5.58 2 2 5.58 2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2ZM5 8.5C5.82843 8.5 6.5 9.17157 6.5 10C6.5 10.8284 5.82843 11.5 5 11.5C4.17157 11.5 3.5 10.8284 3.5 10C3.5 9.17157 4.17157 8.5 5 8.5ZM10 8.5C10.8284 8.5 11.5 9.17157 11.5 10C11.5 10.8284 10.8284 11.5 10 11.5C9.17157 11.5 8.5 10.8284 8.5 10C8.5 9.17157 9.17157 8.5 10 8.5ZM15 8.5C15.8284 8.5 16.5 9.17157 16.5 10C16.5 10.8284 15.8284 11.5 15 11.5C14.1716 11.5 13.5 10.8284 13.5 10C13.5 9.17157 14.1716 8.5 15 8.5Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 20 20',
  },
  circle: {
    path: <circle cx="5.5" cy="6" r="5.5" fill="currentColor" />,
    viewBox: '0 0 11 12',
  },
  logo: {
    path: (
      <g fill="none" fillRule="evenodd">
        <g fillRule="nonzero">
          <g>
            <path
              fill="#36F"
              d="M11.547 6.564H1.991c-.873 0-1.58.735-1.58 1.641s.707 1.641 1.58 1.641h9.556c.873 0 1.581-.735 1.581-1.64 0-.907-.708-1.642-1.58-1.642"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#7CCC33"
              d="M27.537 6.564h-9.536c-.878 0-1.59.735-1.59 1.641s.712 1.641 1.59 1.641h9.536c.879 0 1.591-.735 1.591-1.64 0-.907-.712-1.642-1.59-1.642"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#47B5BD"
              d="M18.522 0H8.965c-.873 0-1.58.735-1.58 1.641s.707 1.641 1.58 1.641h9.557c.873 0 1.58-.735 1.58-1.641S19.396 0 18.523 0"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#F66"
              d="M3.375 0H1.548C.693 0 0 .735 0 1.641s.693 1.641 1.548 1.641h1.827c.855 0 1.548-.735 1.548-1.641S4.23 0 3.375 0"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#FFD900"
              d="M18.965 33.23h-1.828c-.854 0-1.547.735-1.547 1.642 0 .906.693 1.64 1.547 1.64h1.828c.855 0 1.548-.734 1.548-1.64 0-.907-.693-1.641-1.548-1.641"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#36F"
              d="M11.168 33.23H9.345c-.856 0-1.55.735-1.55 1.642 0 .906.694 1.64 1.55 1.64h1.823c.856 0 1.55-.734 1.55-1.64 0-.907-.694-1.641-1.55-1.641"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#7CCC33"
              d="M3.374 33.23H1.549C.694 33.23 0 33.966 0 34.873c0 .906.694 1.64 1.55 1.64h1.824c.855 0 1.55-.734 1.55-1.64 0-.907-.695-1.641-1.55-1.641"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#FFF"
              d="M14.013 26.667H1.576c-.87 0-1.576.734-1.576 1.64 0 .907.706 1.642 1.576 1.642h12.437c.87 0 1.577-.735 1.577-1.641 0-.907-.706-1.641-1.577-1.641"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#7CCC33"
              d="M20.613 26.667h-1.831c-.857 0-1.551.734-1.551 1.64 0 .912.822 1.642 1.676 1.642h1.832c.862 0 1.415-.73 1.415-1.641 0-.907-.694-1.641-1.551-1.641"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#F66"
              d="M27.177 26.667h-1.831c-.857 0-1.551.734-1.551 1.64 0 .912.824 1.642 1.677 1.642h1.831c.862 0 1.415-.73 1.415-1.641 0-.907-.694-1.641-1.55-1.641"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#FFD900"
              d="M11.557 20.103H1.572c-.868 0-1.572.734-1.572 1.64 0 .907.704 1.642 1.572 1.642h9.985c.868 0 1.571-.735 1.571-1.641 0-.907-.703-1.641-1.571-1.641"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#47B5BD"
              d="M21.84 20.103h-5.115c-.854 0-1.546.734-1.546 1.64 0 .907.692 1.642 1.546 1.642h5.114c.854 0 1.546-.735 1.546-1.641 0-.907-.692-1.641-1.546-1.641"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#36F"
              d="M30.452 20.103h-1.827c-.855 0-1.548.734-1.548 1.64 0 .907.693 1.642 1.548 1.642h1.827c.855 0 1.548-.735 1.548-1.641 0-.907-.693-1.641-1.548-1.641"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#F66"
              d="M23.039 13.128H10.602c-.87 0-1.576.735-1.576 1.641 0 .907.705 1.641 1.576 1.641H23.04c.87 0 1.576-.734 1.576-1.64 0-.907-.705-1.642-1.576-1.642"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#FFF"
              d="M3.786 13.128H1.958c-.855 0-1.548.735-1.548 1.641 0 .907.693 1.641 1.548 1.641h1.828c.854 0 1.547-.734 1.547-1.64 0-.907-.693-1.642-1.547-1.642"
              transform="translate(-24 -32) translate(24 32)"
            />
            <path
              fill="#FFD900"
              d="M30.452 13.128h-1.827c-.855 0-1.548.735-1.548 1.641 0 .907.693 1.641 1.548 1.641h1.827c.855 0 1.548-.734 1.548-1.64 0-.907-.693-1.642-1.548-1.642"
              transform="translate(-24 -32) translate(24 32)"
            />
          </g>
        </g>
      </g>
    ),
    viewBox: '0 0 32 37',
  },
  share: {
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 14.08C14.24 14.08 13.56 14.38 13.04 14.85L5.91 10.7C5.96 10.47 6 10.24 6 10C6 9.76 5.96 9.53 5.91 9.3L12.96 5.19C13.5 5.69 14.21 6 15 6C16.66 6 18 4.66 18 3C18 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 3.24 12.04 3.47 12.09 3.7L5.04 7.81C4.5 7.31 3.79 7 3 7C1.34 7 0 8.34 0 10C0 11.66 1.34 13 3 13C3.79 13 4.5 12.69 5.04 12.19L12.16 16.35C12.11 16.56 12.08 16.78 12.08 17C12.08 18.61 13.39 19.92 15 19.92C16.61 19.92 17.92 18.61 17.92 17C17.92 15.39 16.61 14.08 15 14.08Z"
        fill="white"
      />
    ),
    viewBox: '0 0 18 20',
  },
  star: {
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99992 10.5133L11.1199 12.9999L10.0266 8.31325L13.6666 5.15992L8.87325 4.75325L6.99992 0.333252L5.12659 4.75325L0.333252 5.15992L3.97325 8.31325L2.87992 12.9999L6.99992 10.5133Z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 14 13',
  },
};
